export const ENVIRONMENT = 'development' //production | development
export const TOKEN_KEY = ENVIRONMENT === 'production' ? '_iconmama_token' : '_iconmama_token_dev'
export const SITE_KEY = ENVIRONMENT === 'production' ? '6Ld0BLkmAAAAAECagQW1dA8yMo5gOUDq51lB7aS5' : '6Ld0BLkmAAAAAECagQW1dA8yMo5gOUDq51lB7aS5'

export const API_ENDPOINT = ENVIRONMENT === 'production' ? 'https://api.iconmama.in/' : 'https://sapi.iconmama.in/'
export const IDLE_TIME_IN_SECONDS = 300

export const ENCRYPT_AND_DECRYPT_KEY = 'wjEXA38AgXM1FWTxojcsBqykcV9NpX3h'
export const DATA_VECTOR = 'dGEBTb1YQszEhk5G' 